import React from 'react';
import { toast } from 'sonner';
import { Copy, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { revokeAssessmentInvite, assessmentTakeUrl, apiError } from '../../services/assessmentApi';
import { getRegionLabel } from '../../context/RegionContext';

const TONE = { pending: 'bg-slate-500/10 text-slate-600', started: 'bg-amber-500/10 text-amber-600', completed: 'bg-emerald-500/10 text-emerald-600' };

export const InvitesTable = ({ invites, onChange, canManage = true, defaultMin = 4 }) => {
  const copy = async (t) => { await navigator.clipboard.writeText(assessmentTakeUrl(t)).catch(() => {}); toast.success('Personal link copied'); };
  const revoke = async (id) => {
    try { await revokeAssessmentInvite(id); toast.success('Link revoked'); onChange(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="rounded-2xl border bg-card overflow-x-auto" data-testid="invites-table">
      <table className="w-full text-left">
        <thead><tr className="text-[11px] uppercase tracking-wider text-muted-foreground border-b">
          {['Candidate', 'Status', 'Min skills', 'Created by', 'Expires', ''].map((h) => <th key={h} className="py-2.5 px-4 font-semibold">{h}</th>)}
        </tr></thead>
        <tbody>
          {invites.map((i) => (
            <tr key={i.id} className="border-b last:border-0" data-testid={`invite-row-${i.id}`}>
              <td className="py-3 px-4"><p className="text-sm font-medium">{i.candidate_name}</p><p className="text-xs text-muted-foreground">{i.candidate_email || '—'}</p>
                {i.region && <span className="mt-1 inline-block text-[10px] font-semibold uppercase tracking-wider text-muted-foreground bg-muted px-1.5 py-0.5 rounded" data-testid={`invite-region-${i.id}`}>{getRegionLabel(i.region)}</span>}</td>
              <td className="py-3 px-4"><span className={`text-xs font-semibold px-2 py-0.5 rounded-full capitalize ${TONE[i.status]}`}>{i.status}</span></td>
              <td className="py-3 px-4 text-xs text-muted-foreground" data-testid={`invite-min-skills-${i.id}`}>{i.min_skills ? `${i.min_skills} (custom)` : `Default (${i.min_skills_applied || defaultMin})`}</td>
              <td className="py-3 px-4 text-xs text-muted-foreground">{i.created_by}</td>
              <td className="py-3 px-4 text-xs text-muted-foreground">{new Date(i.expires_at).toLocaleDateString()}</td>
              <td className="py-3 px-4">
                <div className="flex justify-end gap-1">
                  <Button size="sm" variant="ghost" onClick={() => copy(i.token)} data-testid={`invite-copy-btn-${i.id}`}><Copy className="h-4 w-4" /></Button>
                  {canManage && <Button size="sm" variant="ghost" className="text-red-500 hover:text-red-600" disabled={i.status === 'completed'} onClick={() => revoke(i.id)} data-testid={`invite-revoke-btn-${i.id}`}><Trash2 className="h-4 w-4" /></Button>}
                </div>
              </td>
            </tr>
          ))}
          {!invites.length && <tr><td colSpan={6} className="py-14 text-center text-sm text-muted-foreground" data-testid="invites-empty">No personal links yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};

export default InvitesTable;
